<template>
    <div class="container">
      <div id="headerBox">
        <el-row type="flex" justify="end">
          <el-col style="padding-top: 10px;" :span="2" :offset="16"><a href="https://piccache.cnki.net/index/helper/manual.html">使用手册</a></el-col>
          <el-col style="padding-top: 10px;" :span="2"><a @click="dialogFormSetting=true">检索设置</a></el-col>
          <el-dialog title="检索设置" :visible.sync="dialogFormSetting">
            <div>
              <p>检索范围</p>
                <el-checkbox-group style="display: flex;flex-wrap: wrap;" v-model="checkboxSetting" size="mini">
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术期刊" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术论文" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术期刊" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术论文" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术期刊" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术论文" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术期刊" border></el-checkbox>
                  <el-checkbox style="margin-bottom: 5px;margin-left: 0;" label="学术论文" border></el-checkbox>
                </el-checkbox-group>
            </div>
            <div>
              <p>检索结果</p>
              <div>
                <div style="margin-top:5px;text-align: left;padding-left:30px;">
                  <span style="margin-right:20px;">每页记录数:</span>
                  <el-radio-group v-model="pageSize">
                    <el-radio :label="10">10</el-radio>
                    <el-radio :label="20">20</el-radio>
                    <el-radio :label="50">50</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:5px;text-align: left;padding-left:30px;">
                  <span style="margin-right:20px;">展示方式:</span>
                  <el-radio-group v-model="showMode">
                    <el-radio :label="0">列表</el-radio>
                    <el-radio :label="1">详情</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:5px;text-align: left;padding-left:30px;">
                  <span style="margin-right:20px;">排序方式:</span>
                  <el-radio-group v-model="descMode">
                    <el-radio :label="0">发表时间</el-radio>
                    <el-radio :label="1">相关度</el-radio>
                    <el-radio :label="2">被引</el-radio>
                    <el-radio :label="3">下载</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:5px;text-align: left;padding-left:30px;">
                  <span style="margin-right:20px;">检索区自动折叠:</span>
                  <el-radio-group v-model="autoFold">
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormSetting = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormSetting = false">确 定</el-button>
            </div>
          </el-dialog>
          <el-col style="padding-top: 10px;" :span="2"><a href="https://i.cnki.net/#/">我的</a></el-col>
          <el-col style="padding-top: 7px;" :span="2"><span style="padding-right:7px;">欢迎</span><el-button style="padding: 5px;" type="primary" plain size="mini">登录<i class="el-icon-arrow-down el-icon--right"></i></el-button></el-col>
        </el-row>
      </div>
      <div id="searchBox">
        <div id="searchHeader">
          <ul class="search-header-ul" @click="changeSearchMode">
            <li class="search-header-li2"><a href="https://ref.cnki.net/ref">引文检索</a></li>
            <li class="search-header-li2"><a href="https://www.cnki.net/?lival=ele">知识元检索</a></li>
            <li class="search-header-li2"><a href="https://kns.cnki.net/KNS8/defaultresult?dbcode=SCDB">一框式检索</a></li>
            <li class="search-header-li1" :class="{ 'activeh': isActive === 'authors_article' }">作者发文检索</li>
            <li class="search-header-li1" :class="{ 'activeh': isActive === 'major' }">专业检索</li>
            <li class="search-header-li1" :class="{ 'activeh': isActive === 'senior' }">高级检索</li>
          </ul>
        </div>
        <div id="searchBody">
          <div id="leftBox" v-show="showLeftBox&&(!fold||isActive=='authors_article'||isActive=='major')">
            <span>文献分类</span>
            <el-button @click="showLeftBox = false" style="margin-left:80px;" type="primary" icon="el-icon-arrow-left" size="mini" circle></el-button>
            <div style="font-size:13px;">
              <span style="margin:20px;">全选</span>
              <span>清除</span>
            </div>
            <el-tree
              :props="treeProps"
              :load="loadNode"
              lazy
              show-checkbox
              @check-change="treeHandleCheckChange">
            </el-tree>
          </div>
          <div id="middleBox" :class="{ 'middleWidth' : !showLeftBox, 'middleWidth2' : fold&&isActive!='authors_article'&&isActive!='major' }">
            <div v-show="!showLeftBox&&(!fold||isActive=='authors_article'||isActive=='major')" style="position:absolute;left:1px;top:20px;background-color:#B4D3EC;color:white;border-radius:0px 5px 5px 0;padding:16px 0"  @click="leftBoxDialog"><a href="javascript:void(0)"><span style="font-size:13px;writing-mode:vertical-lr;height:52px;color:#FFFFFF;">文献分类<i class="el-icon-arrow-right"></i></span></a></div>
            <!-- 高级检索 -->
            <div v-show="isActive=='senior'">
              <div style="margin-top: 15px;margin-left: 50px;margin-right: 10px">
                <div style="display: flex;">
                  <div style="width: 130px;"></div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems[0]" placeholder="请选择">
                    <el-option label="主题" value="1"></el-option>
                    <el-option label="作者" value="2"></el-option>
                    <el-option label="文献来源" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs[0]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;"></div>
                </div>  
              </div>
              <div v-show="!fold" style="margin-top: 15px;margin-left: 50px;margin-right: 10px">
                <div style="display: flex;">
                  <div style="width: 130px;">
                    <el-select class="select-item-mode0" style="margin-right:5px;" v-model="selectLogics[1]" placeholder="请选择">
                      <el-option label="AND" value="1"></el-option>
                      <el-option label="OR" value="2"></el-option>
                      <el-option label="NOT" value="3"></el-option>
                    </el-select>
                  </div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems[1]" placeholder="请选择">
                    <el-option label="主题" value="1"></el-option>
                    <el-option label="作者" value="2"></el-option>
                    <el-option label="文献来源" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs[1]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;">
                    <el-button v-show="true" icon="el-icon-minus" plain circle></el-button>
                    <el-button v-show="false" icon="el-icon-plus" plain circle></el-button>
                  </div>
                </div>  
              </div>
              <div v-show="!fold" style="margin-top: 15px;margin-left: 50px;margin-right: 10px;">
                <div style="display: flex;">
                  <div style="width: 130px;">
                    <el-select class="select-item-mode0" style="margin-right: 5px;" v-model="selectLogics[2]" placeholder="请选择">
                      <el-option label="AND" value="1"></el-option>
                      <el-option label="OR" value="2"></el-option>
                      <el-option label="NOT" value="3"></el-option>
                    </el-select>
                  </div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems[2]" placeholder="请选择">
                    <el-option label="主题" value="1"></el-option>
                    <el-option label="作者" value="2"></el-option>
                    <el-option label="文献来源" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs[2]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;">
                    <el-button v-show="true" icon="el-icon-minus" plain circle></el-button>
                    <el-button v-show="true" icon="el-icon-plus" plain circle></el-button>
                  </div>
                </div>  
              </div>
            </div>
            <!-- 专业检索 -->
            <div v-show="isActive=='major'" style="margin: 10px 60px;">
              <el-input
                type="textarea"
                rows=5
                placeholder="请输入内容"
                v-model="majorText">
              </el-input>
            </div>
            <!-- 作者发文检索 -->
            <div v-show="isActive=='authors_article'">
              <div style="margin-top: 15px;margin-left: 50px;margin-right: 10px">
                <div style="display: flex;">
                  <div style="width: 130px;"></div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems2[0]" placeholder="请选择">
                    <el-option label="作者" value="1"></el-option>
                    <el-option label="作者单位" value="2"></el-option>
                    <el-option label="第一作者" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs2[0]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes2[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;"></div>
                </div>  
              </div>
              <div style="margin-top: 15px;margin-left: 50px;margin-right: 10px">
                <div style="display: flex;">
                  <div style="width: 130px;">
                    <el-select class="select-item-mode0" style="margin-right:5px;" v-model="selectLogics2[1]" placeholder="请选择">
                      <el-option label="AND" value="1"></el-option>
                      <el-option label="OR" value="2"></el-option>
                      <el-option label="NOT" value="3"></el-option>
                    </el-select>
                  </div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems2[1]" placeholder="请选择">
                    <el-option label="作者" value="1"></el-option>
                    <el-option label="作者单位" value="2"></el-option>
                    <el-option label="第一作者" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs2[1]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes2[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;">
                    <el-button v-show="true" icon="el-icon-minus" plain circle></el-button>
                    <el-button v-show="false" icon="el-icon-plus" plain circle></el-button>
                  </div>
                </div>  
              </div>
              <div style="margin-top: 15px;margin-left: 50px;margin-right: 10px;">
                <div style="display: flex;">
                  <div style="width: 130px;">
                    <el-select class="select-item-mode0" style="margin-right: 5px;" v-model="selectLogics2[2]" placeholder="请选择">
                      <el-option label="AND" value="1"></el-option>
                      <el-option label="OR" value="2"></el-option>
                      <el-option label="NOT" value="3"></el-option>
                    </el-select>
                  </div>
                  <el-select class="select-item-mode1" style="width: 200px;" v-model="selectItems2[2]" placeholder="请选择">
                    <el-option label="作者" value="1"></el-option>
                    <el-option label="作者单位" value="2"></el-option>
                    <el-option label="第一作者" value="3"></el-option>
                  </el-select>
                  <el-input class="select-input" placeholder="请输入内容" v-model="inputs2[2]"></el-input>
                  <div style="width: 120px;">
                    <el-select class="select-item-mode2" v-model="selectModes2[0]" placeholder="请选择">
                      <el-option label="精确" value="1"></el-option>
                      <el-option label="模糊" value="2"></el-option>
                    </el-select>
                  </div>
                  <div style="width:200px;">
                    <el-button v-show="true" icon="el-icon-minus" plain circle></el-button>
                    <el-button v-show="true" icon="el-icon-plus" plain circle></el-button>
                  </div>
                </div>  
              </div>
            </div>
            <!-- 扩展 -->
            <div style="margin-top: 20px;">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="基金文献"></el-checkbox>
                <el-checkbox label="中英文扩展"></el-checkbox>
                <el-checkbox label="同义词扩展"></el-checkbox>
              </el-checkbox-group>
            </div>
            <!-- 时间范围 -->
            <div style="margin-top: 20px;display: flex;justify-content: center;">
              <p style="font-size:13px;"><b>发表时间：</b></p>
              <el-date-picker style="margin-right:5px;"
                v-model="startTime"
                type="date"
                placeholder="开始日期">
              </el-date-picker>
              <el-date-picker style="margin-right:5px;"
                v-model="endTime"
                type="date"
                placeholder="结束日期">
              </el-date-picker>
              <p style="font-size:13px;margin-left:10px;"><b>更新时间：</b></p>
              <el-select class="select-item-mode0" style="margin-right:5px;" v-model="selectLogics[1]" placeholder="请选择">
                <el-option label="不限" value="1"></el-option>
                <el-option label="最近一周" value="2"></el-option>
                <el-option label="最近一月" value="3"></el-option>
                <el-option label="最近半年" value="3"></el-option>
                <el-option label="今年迄今" value="3"></el-option>
                <el-option label="上一年度" value="3"></el-option>
              </el-select>
            </div>
            <hr />
            <!-- 提交按钮及重置条件 -->
            <div style="margin: 20px 0;display: flex;justify-content: center;">
              <a href="javascript:void(0)"><p style="font-size:14px;color: #2b2b2b;text-align: center;" @click="clear()">重置条件</p></a>
              <el-button style="width:200px;margin-left: 30px;" @click="search()" type="primary">检索</el-button>
            </div>
            <!-- 折叠 -->
            <el-button v-show="!fold&&isActive=='senior'" @click="fold=true" style="position: absolute;bottom: -15px;" icon="el-icon-arrow-up" size="mini" circle></el-button>
            <el-button v-show="fold&&isActive=='senior'" @click="fold=false" style="position: absolute;bottom: -15px;" icon="el-icon-arrow-down" size="mini" circle></el-button>
          </div>
          <div v-show="!fold||isActive=='authors_article'||isActive=='major'" id="reightBox">
            <!-- 高级检索使用方法 -->
            <div v-show="isActive=='senior'" style="overflow:auto;width: 300px;height: 400px;">
              <dl>
                <dt><span>高级检索使用方法：</span><a href="http://piccache.cnki.net/index/helper/manuals.html#frame2-1-2" target="_blank" title="查看详细说明">&gt;&gt;</a></dt>     
                <dd>
                    <p>高级检索支持使用运算符*、+、-、''、""、()进行同一检索项内多个检索词的组合运算，检索框内输入的内容不得超过120个字符。</p>
                    <p> 输入运算符*(与)、+(或)、-(非)时，前后要空一个字节，优先级需用英文半角括号确定。</p>
                    <p>
                        若检索词本身含空格或*、+、-、()、/、%、=等特殊符号，进行多词组合运算时，为避免歧义，须将检索词用英文半角单引号或英文半角双引号引起来。
                    </p>
                </dd>
                <dt> 例如：</dt>
                <dd>         
                    <p>（1）篇名检索项后输入：神经网络 * 自然语言，可以检索到篇名包含“神经网络”及“自然语言”的文献。</p>
                    <p>（2）主题检索项后输入：(锻造 + 自由锻) * 裂纹，可以检索到主题为“锻造”或“自由锻”，且有关“裂纹”的文献。</p>
                    <p>（3）如果需检索篇名包含“digital library”和“information service”的文献，在篇名检索项后输入：'digital library' * 'information service'。</p>
                    <p>（4）如果需检索篇名包含“2+3”和“人才培养”的文献，在篇名检索项后输入：'2+3' * 人才培养。</p>
                </dd>
              </dl>
            </div>
            <!-- 专业检索使用方法 -->
            <div v-show="isActive=='major'" style="overflow:auto;width: 300px;height: 400px;">
              <dl>
                <dt><span>专业检索使用方法：</span><a href="http://piccache.cnki.net/index/helper/manuals.html#frame2-1-5" target="_blank" title="查看详细说明">&gt;&gt;</a></dt>
                <dt><span>可检索字段：</span></dt>
                <dd>
                  <p>SU%=主题,TKA=篇关摘,KY=关键词,TI=篇名,FT=全文,AU=作者,FI=第一作者,RP=通讯作者,AF=作者单位,FU=基金,AB=摘要,CO=小标题, RF=参考文献,CLC=分类号,LY=文献来源, DOI=DOI,CF=被引频次</p>
                </dd>
                <dt>示例：</dt>
                <dd>
                    <p>1）TI='生态' and KY='生态文明' and (AU % '陈'+'王' ) 可以检索到篇名包括“生态”并且关键词包括“生态文明”并且作者为“陈”姓和“王”姓的所有文章；</p>
                    <p>2）SU='北京'*'奥运' and FT='环境保护' 可以检索到主题包括“北京”及“奥运”并且全文中包括“环境保护”的信息；</p>
                    <p>3）SU=('经济发展'+'可持续发展')*'转变'-'泡沫' 可检索“经济发展”或“可持续发展”有关“转变”的信息，并且可以去除与“泡沫”有关的部分内容。</p>
                </dd>
              </dl>
            </div>
            <!-- 作者发文检索使用方法： -->
            <div v-show="isActive=='authors_article'" style="overflow:auto;width: 300px;height: 400px;">
              <dl>        
                <dt class="default-tit"><span>作者发文检索使用方法：</span><a href="http://piccache.cnki.net/index/helper/manuals.html#frame2-1-3" target="_blank" title="查看详细说明">&gt;&gt;</a></dt>
                <dd class="default-tip">通过作者姓名、单位等信息，查找作者发表的文献及被引和下载情况。</dd>
                <dt class="default-subtit"><span>检索字段介绍：</span></dt>
                <dd>
                  <h6><i></i><span>作者/第一作者/通讯作者：</span></h6>
                  <p>输入作者姓名，可在右侧引导列表中根据机构名称进行勾选，精准定位。</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  //add by cyt 2021.9.3 start
    props:{
      searchArticle:{
          type:Function,
          default:null
      }
  },
  //add by cyt 2021.9.3 end
  components: {},
  data () {
    return {
      dialogFormSetting: false,
      checkboxSetting: [],
      pageSize: 10,
      showMode: 0,
      descMode: 0,
      autoFold: 0,
      isActive: 'senior',
      showLeftBox: false,
      treeProps: {
        label: 'name',
        children: 'zones'
      },
      aaa: '1',
      bbb: '1',
      inputs: ['', '', ''],
      selectLogics: ['1', '1', '1'],
      selectItems: ['1', '2', '3'],
      selectModes: ['1', '1', '1'],
      majorText: '',
      inputs2: ['', '', ''],
      selectLogics2: ['1', '1', '1'],
      selectItems2: ['1', '2', '3'],
      selectModes2: ['1', '1', '1'],
      checkList: ['中英文扩展'],
      startTime: '',
      endTime: '',
      fold: false,
      treeCount: 1
    }
  },
  computed: {},
  watch: {},
  methods: {
    //add by cyt 2021.9.3 start
    clear(){
      this.searchArticle(false)
    },
    search(){
      this.searchArticle(true)
    },
    //add by cyt 2021.9.3 end
    changeSearchMode(e) {
      if(e.target.innerHTML === '高级检索') {
        this.isActive = 'senior'
      }
      if(e.target.innerHTML === '专业检索') {
        this.isActive = 'major'
      }
      if(e.target.innerHTML === '作者发文检索') {
        this.isActive= 'authors_article'
      }
      console.log(this.isActive)
    },
    leftBoxDialog () {
      this.showLeftBox = true
    },
    treeHandleCheckChange (data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    handleNodeClick (data) {
      console.log(data)
    },
    loadNode (node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: 'region1' }, { name: 'region2' }])
      }
      if (node.level > 3) return resolve([])

      var hasChild
      if (node.data.name === 'region1') {
        hasChild = true
      } else if (node.data.name === 'region2') {
        hasChild = false
      } else {
        hasChild = Math.random() > 0.5;
      }

      setTimeout(() => {
        var data
        if (hasChild) {
          data = [{
            name: 'zone' + this.count++
          }, {
            name: 'zone' + this.count++
          }];
        } else {
          data = []
        }

        resolve(data)
      }, 500)
    }
  },
  created () {},
  mounted () {},
  beforeCreate () {},
  beforeMount () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  activated () {}
}
</script>

<style>
.container {
  width: 100%;
  height: 500px;
  margin: 0;
  padding: 0;
}
.container li {
  list-style: none;
}
.container a {
  text-decoration:none;
}
.container input {
  border-radius: 0 !important;
}
#headerBox {
  font-size: 13px;
  height: 41px;
  border-top: 3px solid #213e82;
  border-bottom: 1px solid #EDEEF0;
  background-color: #FCFCFC;
  height: 36px!important;
  border: none!important;
  background-color: #e9e9e7!important;
}
#headerBox a {
    color: #4C4C4C;
    display: inline-block;
    line-height: 16px;
    cursor: pointer;
    position: relative;
    z-index: 8129;
    padding: 0 2px 0 0;
}
#searchBox { 
   /* height: 400px;  */
  width: 100%;
  min-height: 76px;
  /* border-bottom: 1px solid #e4e4e4; */
}
#searchBody {
  width: auto;
  margin-top: -3px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
#searchHeader {
  height: 80px;
  /* margin-top: 50px; */
  background: url(https://piccache.cnki.net/kdn/KNS8/Content/images/gb/banner-bg2.jpg) repeat-x center top #fff;
}
.activeh {
  color: #fff !important;
  background-color: #6c9ef5;
  border-radius: 4px 4px 0 0;
}
.search-header-ul {
  float: right;
  height: 43px;
  margin-top: 33px;
  margin-bottom: 0;
  margin-right: 294px;
}
.search-header-li1 {
  float: right;
  height: 43px;
  padding: 0 20px;
  font-size: 15px;
  line-height: 43px;
  color: #2b2b2b;
  cursor: pointer;
}
.search-header-li2 {
  float: right;
  font-size: 13px;
  width: 100px;
  padding: 0;
  margin-left: 16px;
  margin-top: 16px;
  text-align: right;
}
#leftBox {
  /* background-color: red; */
  width: 200px;
  /* height: 400px; */
  margin-left: 10px;
  outline-style: solid;
  outline-width: 1px;
  outline-color: #d9d2d1;
  box-shadow: 4px 6px 4px #888888;
}
#middleBox {
  /* background-color: red; */
  width: 900px;
  /* height: 400px; */
  margin-right: 10px;
  outline-style: solid;
  outline-width: 1px;
  outline-color: #d9d2d1;
  box-shadow: 4px 6px 4px #888888;
  position: relative;
}
.middleWidth {
  width: 1100px !important;
}
.middleWidth2 {
  width: 1400px !important;
}
#reightBox {
  /* background-color: red; */
  width: 300px;
  height: 400px;
  margin-right: 10px;
  outline-style: solid;
  outline-width: 1px;
  outline-color: #d9d2d1;
  box-shadow: 4px 6px 4px #888888;
}
#reightBox p {
  font-size: 13px;
  font-weight: 300;
  text-align: left;
}
#reightBOx dt span {
  padding-bottom: 10px;
  font-size: 15px;
  color: #000;
  font-weight: normal;
  border-bottom: 1px solid #cdd4dc;
}
#reightBox dd {
  margin-inline-start: 4px;
  font-size: 13px;
  font-weight: 300;
  text-align: left;
}
.select-item-mode0 input {
  border-radius: 0 !important;
}
.select-item-mode1 input {
  border-right-width: 0px !important;
  border-radius: 0 !important;
}
.select-input input {
  border-radius: 0 !important;
}
.select-item-mode2 input {
  border-left-width: 0px !important;
  border-radius: 0 !important;
}
</style>
